// SortableTask.jsx
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Card, CardContent, Typography, Avatar, Box } from '@mui/material';

const SortableTask = ({ id, task }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    cursor: 'grab',
  };

  if (!task) {
    return (
      <Box
        ref={setNodeRef}
        {...attributes}
        {...listeners}
        sx={{
          minHeight: 60,
          border: '1px dashed #ccc',
          borderRadius: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#aaa',
          fontStyle: 'italic',
          ...style,
        }}
      >
        Arrastra aquí
      </Box>
    );
  }

  return (
    <Card ref={setNodeRef} {...attributes} {...listeners} sx={{ p: 1, ...style }} variant="outlined">
      <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1 }}>
        <Box>
          <Typography variant="body2" fontWeight={500}>
            {task.title}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {task.id}
          </Typography>
        </Box>
        <Avatar sx={{ bgcolor: '#18586b', width: 28, height: 28, fontSize: 14 }}>{task.user}</Avatar>
      </CardContent>
    </Card>
  );
};

export default SortableTask;

